import { getUserFullName } from '@lumapps/user/utils/getUserFullName';

import { NOTIFICATIONS_CENTER } from '../../keys';
import { NotificationMeta, NotificationTypes } from '../../types';
import { getContentTitle, getParentContentTitle, isTheContentAPlayVideo, isTheContentAPost } from '../contentUtils';
import { getCommentLink, getContentLink, getEmptyRoute, getPlayVideoLink, getPostLink } from '../linksUtils';

const notificationTypeReaction: Record<string, NotificationMeta> = {
    [NotificationTypes.Reaction]: {
        hasThumbnail: true,
        hasBadge: false,
        iconProps: {},
        getDescription: ({ notification, count, senderDetails, translation, currentLanguage }) => {
            // Get content title.
            const contentTitle = getContentTitle(translation, notification);

            let key: string;

            if (isTheContentAPost(notification) && notification?.commentDetails) {
                key = NOTIFICATIONS_CENTER.REACTION_POST_COMMENT;
            } else if (isTheContentAPost(notification)) {
                key = NOTIFICATIONS_CENTER.REACTION_POST;
            } else if (notification?.commentDetails) {
                key = NOTIFICATIONS_CENTER.REACTION_CONTENT_COMMENT;
            } else {
                key = NOTIFICATIONS_CENTER.REACTION;
            }

            const reactedTo =
                count > 1
                    ? translation.translateAndReplace(
                          translation.pluralize(NOTIFICATIONS_CENTER.REACTION_REACTED_TO_MULTI, count - 1),
                          {
                              NB_OTHERS: count - 1,
                              REACTED_TO: translation.pluralize(NOTIFICATIONS_CENTER.REACTION_REACTED_TO, count - 1),
                          },
                      )
                    : translation.pluralize(NOTIFICATIONS_CENTER.REACTION_REACTED_TO, count);

            return translation.translateAndReplace(key, {
                /** Display reaction author name. */
                AUTHOR_NAME: getUserFullName(senderDetails, currentLanguage),
                /** Display content name, only for reactions on Content. */
                CONTENT_TITLE: contentTitle,
                /** Display community name, only for reactions on posts. */
                COMMUNITY_NAME: getParentContentTitle(translation, notification),
                /** Display post name, only for reactions on posts. */
                POST_TITLE: contentTitle,
                /** Display pluralizing "reacted to"
                 * We need to use two keys to deal with:
                 * - ONE - reacted to
                 * - TWO - and X other reacted
                 * - MANY - and X others reacted
                 * */
                REACTED_TO: reactedTo,
            });
        },
        getRoute: getEmptyRoute,
        getLinkAs: (params) => {
            if (!params) {
                return null;
            }

            if (params.notification?.commentDetails) {
                return getCommentLink(params);
            }

            if (isTheContentAPost(params.notification)) {
                return getPostLink(params);
            }

            if (isTheContentAPlayVideo(params.notification)) {
                return getPlayVideoLink(params);
            }
            return getContentLink(params);
        },
    },
};

export { notificationTypeReaction };
